var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import { defaultProps } from './defaults';
import { CollapsePanel } from './CollapsePanel';
import { DivTag } from '../../Utils/AtomicTag';
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(props) {
        var _this = _super.call(this, props) || this;
        _this.onPanelClick = function (key) {
            var activeKey = _this.state.activeKey;
            var _a = _this.props, accordion = _a.accordion, onChange = _a.onChange;
            var newActiveKey = [];
            if (accordion) {
                newActiveKey = activeKey[0] === key ? [] : [key];
            }
            else {
                newActiveKey = __spread(activeKey);
                var pos = newActiveKey.indexOf(key);
                if (pos > -1) {
                    newActiveKey.splice(pos, 1);
                }
                else {
                    newActiveKey.push(key);
                }
            }
            _this.setState({ activeKey: newActiveKey });
            onChange(newActiveKey, key);
        };
        _this.getNewPanel = function (child, index) {
            if (!child)
                return null;
            var panelKey = child.key || String(index);
            var _a = child.props, header = _a.header, children = _a.children, disabled = _a.disabled;
            var accordion = _this.props.accordion;
            var isActive = false;
            if (accordion) {
                isActive = _this.state.activeKey[0] === panelKey;
            }
            else {
                isActive = _this.state.activeKey.indexOf(panelKey) > -1;
            }
            var props = {
                panelKey: panelKey,
                header: header,
                children: children,
                isActive: isActive,
                hasBorder: _this.props.hasBorder,
                accordion: accordion,
                iconPosition: _this.props.iconPosition,
                onItemChange: disabled ? null : _this.onPanelClick,
            };
            return React.cloneElement(child, props);
        };
        var defaultActiveKey = props.defaultActiveKey, activeKey = props.activeKey;
        var defaultActiveKeys = Array.isArray(defaultActiveKey)
            ? defaultActiveKey
            : [defaultActiveKey];
        var activeKeys = Array.isArray(activeKey) ? activeKey : [activeKey];
        _this.state = {
            activeKey: __spread(defaultActiveKeys, activeKeys).map(function (key) { return String(key); }),
        };
        return _this;
    }
    Collapse.prototype.render = function () {
        var _this = this;
        var _a = this.props, hasBorder = _a.hasBorder, children = _a.children, accordion = _a.accordion, defaultActiveKey = _a.defaultActiveKey, iconPosition = _a.iconPosition, activeKey = _a.activeKey, onChange = _a.onChange, rest = __rest(_a, ["hasBorder", "children", "accordion", "defaultActiveKey", "iconPosition", "activeKey", "onChange"]);
        var boxCls = ['rounded', 'overflow-hidden'];
        if (hasBorder)
            boxCls = boxCls.concat(['border', 'border-solid', 'border-gray-200', 'border-b-0']);
        return (React.createElement(DivTag, __assign({ atomics: boxCls }, rest, { name: Collapse.NAME }), React.Children.map(children, function (child, index) {
            return _this.getNewPanel(child, index);
        })));
    };
    Collapse.Panel = CollapsePanel;
    Collapse.NAME = 'collapse';
    Collapse.displayName = 'Collapse';
    Collapse.defaultProps = defaultProps;
    return Collapse;
}(React.PureComponent));
export { Collapse };
